import React from "react";
import ViewHotels from "../component/Hotel/ViewHotels";

const Hotels = () => {
  return (
    <>
      <ViewHotels />
    </>
  );
};

export default Hotels;
